function normalizeClipboardFile(file, index = 0) {
  const name = (file.name || '').trim();
  if (name && name !== 'blob') {
    return file;
  }
  const mime = file.type || 'image/png';
  const ext = mime.split('/')[1]?.replace('jpeg', 'jpg') || 'png';
  const suffix = index > 0 ? `-${index + 1}` : '';
  return new File([file], `pasted-${Date.now()}${suffix}.${ext}`, { type: mime });
}

export function filesFromClipboard(event) {
  const items = event.clipboardData && event.clipboardData.items
    ? Array.from(event.clipboardData.items)
    : [];
  const files = [];
  items.forEach((item, index) => {
    if (item.kind !== 'file') {
      return;
    }
    const file = item.getAsFile();
    if (!file) {
      return;
    }
    files.push(normalizeClipboardFile(file, index));
  });
  return files;
}
